(() => {
    // cache celé odpovědi (text + nastavení)
    let cachedTts = null;

    let ttsRunId = 0;
    let pauseTimer = null;
    let isPlaying = false;

    // stopky (elapsed)
    let elapsedTimer = null;
    let elapsedStart = 0;

    const btn = document.querySelector('#tts-toggle');
    if (!btn) return;

    // --- Feature detection: když prohlížeč nezná SpeechSynthesisUtterance, zruš tlačítko a konči
    const synth = window.speechSynthesis;
    const supportsTts =
        !!synth &&
        typeof synth.speak === 'function' &&
        typeof synth.cancel === 'function' &&
        typeof window.SpeechSynthesisUtterance === 'function';

    if (!supportsTts) {
        btn.remove(); // nebo: btn.hidden = true;
        return;
    }
    // ---

    const iconEl = btn.querySelector('.tts-icon');
    const labelEl = btn.querySelector('.tts-label');
    const durationEl = btn.querySelector('.tts-duration');

    const TTS_URL = btn.dataset.ttsUrl;
    if (!TTS_URL) {
        console.error('Chybí data-tts-url na #tts-toggle');
        return;
    }

    let estimateLabel = durationEl ? (durationEl.textContent || '').trim() : null;

    function clamp(n, min, max) {
        n = Number(n);
        if (Number.isNaN(n)) return min;
        return Math.max(min, Math.min(max, n));
    }

    function formatMMSS(sec) {
        sec = Math.max(0, Math.floor(sec));
        const m = Math.floor(sec / 60);
        const s = sec % 60;
        return `${m}:${String(s).padStart(2, '0')}`;
    }

    function setButtonState(playing) {
        isPlaying = playing;
        btn.dataset.state = playing ? 'stop' : 'play';
        btn.setAttribute('aria-pressed', playing ? 'true' : 'false');
        if (iconEl) iconEl.textContent = playing ? '⏹' : '▶';
        if (labelEl) labelEl.textContent = playing ? 'Zastavit' : 'Přehrát článek';
    }

    function stopElapsed(restoreEstimate = true) {
        if (elapsedTimer) {
            clearInterval(elapsedTimer);
            elapsedTimer = null;
        }
        elapsedStart = 0;

        if (restoreEstimate && durationEl && estimateLabel) {
            durationEl.textContent = estimateLabel;
        }
    }

    function startElapsed(myRunId) {
        if (!durationEl) return;

        stopElapsed(false);
        elapsedStart = performance.now();
        durationEl.textContent = '0:00';

        elapsedTimer = setInterval(() => {
            if (myRunId !== ttsRunId) return;
            const sec = (performance.now() - elapsedStart) / 1000;
            durationEl.textContent = formatMMSS(sec);
        }, 250);
    }

    async function fetchTtsPayload() {
        if (cachedTts) return cachedTts;

        const res = await fetch(TTS_URL, {
            headers: { 'Accept': 'application/json' },
            credentials: 'same-origin'
        });

        if (!res.ok) throw new Error(`TTS text fetch failed: ${res.status} ${res.statusText}`);

        const data = await res.json();

        const payload = {
            text: String(data.text || '').replace(/\s+/g, ' ').trim(),
            lang: String(data.lang || 'cs-CZ'),
            rate: clamp(data.rate ?? 1.0, 0.5, 2.0),
            pitch: clamp(data.pitch ?? 1.0, 0.0, 2.0),
            durationLabel: data.duration_label_est ? String(data.duration_label_est) : null
        };

        if (payload.durationLabel) estimateLabel = payload.durationLabel;

        cachedTts = payload;
        return payload;
    }

    function stopTts(restoreEstimate = true) {
        ttsRunId++;
        if (pauseTimer) {
            clearTimeout(pauseTimer);
            pauseTimer = null;
        }
        synth.cancel();

        stopElapsed(restoreEstimate);
        setButtonState(false);
    }

    function speakWithPauses(text, { lang = 'cs-CZ', rate = 1.0, pitch = 1.0 } = {}) {
        stopTts(false);
        setButtonState(true);

        const myRunId = ttsRunId;
        startElapsed(myRunId);

        const parts = text.split(/\[\[PAUSE:(\d+)\]\]/g);
        let i = 0;
        let needsCancelDelay = true;

        const finish = () => {
            if (myRunId !== ttsRunId) return;
            stopElapsed(true);
            setButtonState(false);
        };

        const next = () => {
            if (myRunId !== ttsRunId) return;
            if (i >= parts.length) return finish();

            const chunk = parts[i++];

            if (/^\d+$/.test(chunk)) {
                const ms = Math.min(parseInt(chunk, 10), 5000);
                pauseTimer = setTimeout(() => {
                    pauseTimer = null;
                    next();
                }, ms);
                return;
            }

            const spoken = chunk.replace(/\s+/g, ' ').trim();
            if (!spoken) return next();

            const u = new SpeechSynthesisUtterance(spoken);
            u.lang = lang;
            u.rate = rate;
            u.pitch = pitch;
            u.onend = () => next();
            u.onerror = (e) => {
                if (myRunId !== ttsRunId) return;
                if (e.error === 'canceled' || e.error === 'interrupted') return;
                console.warn('TTS onerror:', e.error);
                next();
            };

            if (needsCancelDelay) {
                needsCancelDelay = false;
                setTimeout(() => {
                    if (myRunId !== ttsRunId) return;
                    synth.speak(u);
                }, 50);
            } else {
                synth.speak(u);
            }
        };

        next();
    }

    btn.addEventListener('click', async () => {
        if (isPlaying || synth.speaking || synth.pending || pauseTimer) {
            stopTts(true);
            return;
        }

        try {
            btn.disabled = true;
            if (iconEl) iconEl.textContent = '⏳';
            if (labelEl) labelEl.textContent = 'Načítám…';

            // iOS Safari vyžaduje synth.speak() synchronně v user-gesture kontextu.
            // Prázdná utterance "odemkne" audio kontext dříve, než nastane await.
            // Na Android/Chrome je tento unlock zbytečný a způsobuje problémy po cancel().
            if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
                const unlock = new SpeechSynthesisUtterance('');
                unlock.volume = 0;
                synth.speak(unlock);
            }

            const payload = await fetchTtsPayload();
            if (!payload.text) { setButtonState(false); return; }

            if (durationEl && estimateLabel) durationEl.textContent = estimateLabel;

            speakWithPauses(payload.text, payload);
        } catch (e) {
            console.error(e);
            stopTts(true);
        } finally {
            btn.disabled = false;
            if (iconEl) iconEl.textContent = isPlaying ? '⏹' : '▶';
            if (labelEl) labelEl.textContent = isPlaying ? 'Zastavit' : 'Přehrát článek';
        }
    });

    setButtonState(false);
    if (durationEl && estimateLabel) durationEl.textContent = estimateLabel;

    const stopOnLeave = () => {
        if (isPlaying || synth.speaking || synth.pending || pauseTimer) {
            stopTts(false);
        }
    };

    window.addEventListener('pagehide', stopOnLeave);
    window.addEventListener('beforeunload', stopOnLeave);

    // volitelné (např. mobil / přepnutí tabu)
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') stopOnLeave();
    });
})();
